import { render } from "./ApprovedBlock.vue?vue&type=template&id=955f1ec0"
import script from "./ApprovedBlock.vue?vue&type=script&lang=js"
export * from "./ApprovedBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__